import Marquee from "react-fast-marquee";

export default function MarqueeBand({ items, dark = false, className = "" }) {
  return (
    <div
      className={`border-y-2 border-black py-4 md:py-5 overflow-hidden ${
        dark ? "bg-ink text-lime" : "bg-lime text-black"
      } ${className}`}
      data-testid="marquee-band"
    >
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-sm md:text-base font-bold uppercase tracking-[0.3em]">
            <span className="mx-6 md:mx-10">{item}</span>
            <span className={`inline-block w-2.5 h-2.5 ${dark ? "bg-lime" : "bg-black"}`} />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
